import { Typography, styled } from '@mui/material';

const StyledSessionSideListHeaderTitle = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(18),
  fontWeight: 500
}));

export default StyledSessionSideListHeaderTitle;
